<script>
  import User from './components/User.vue'

  export default {
    name: 'App',
    components: { User },
    props: {},

    metaInfo () {
      return {
        title: this.pageName,
        titleTemplate: chunk => chunk ? `${chunk} | ${this.siteName}` : this.siteName,
        meta: [
          {
            vmid: 'twitter:title',
            name: 'twitter:title',
            content: this.pageName,
            template: chunk => chunk ? `${chunk} | ${this.siteName}` : this.siteName,
          },
        ],
      }
    },

    data () {
      return {
        pageName: '',
        siteName: 'さとみん☆のプリチャンコーデあつめ',
      }
    },

    computed: {
    },

    watch: {
      '$route' () {
        this.updatePageName()
      },
    },

    created () {
    },

    mounted () {
      this.updatePageName()
    },

    beforeDestroy () {
    },

    methods: {
      updatePageName () {
        const { path, name } = this.$route
        const isTopPage = [ '/', '/index' ].includes(path)
        this.pageName = isTopPage ? '' : name
        return this
      },
    },

    filters: {
    },
  }
</script>


<template>
  <div id="app">
    <User />
    <router-view />
  </div>
</template>


<style lang="scss">
  @import "~@/stylesheets/common";

  html,
  body,
  #app {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    color: $page-fg-color;
    background-color: $page-bg-color;

    // // A2 サイズ
    // @media print {
    //   width: 594mm;
    //   height: 420mm;
    // }
  }
</style>
